import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogAccountContent: React.FC<Props> = ({ log }) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );
    const cashDiff = log.diff.find(
        (d) => d.field === "generalLedgerAccountId" || d.field === "accountId",
    );
    const accrualDiff = log.diff.find((d) => d.field === "accrualAccountId");
    const ledgerUpdates = [
        cashDiff
            ? { label: "Cash ledger", value: cashDiff.after?.valueLabel ?? "" }
            : null,
        accrualDiff
            ? {
                  label: "Accrual ledger",
                  value: accrualDiff.after?.valueLabel ?? "",
              }
            : null,
    ].filter(
        (update): update is { label: string; value: string } => update !== null,
    );

    return (
        <>
            <strong>{authorComponent}</strong> updated{" "}
            {ledgerUpdates.map((update, index) => (
                <React.Fragment key={update.label}>
                    {index > 0 ? " and " : null}
                    {update.label} to <strong>{update.value}</strong>
                </React.Fragment>
            ))}
            .
        </>
    );
};
